import { useState, useEffect, useRef, FormEvent } from 'react';

const LOGO = 'https://static.readdy.ai/image/0e9775581447daa16a16441c9f113381/d044e470ba7f6b4a0af6e0746390bd01.png';

const currentDrop = [
  {
    name: 'Hound Heavyweight Hoodie',
    price: '$148',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20a%20heavyweight%20oversized%20streetwear%20hoodie%20in%20washed%20charcoal%20black%20with%20subtle%20running%20wolf%20dog%20embroidery%20on%20chest%2C%20laid%20on%20warm%20cream%20paper%20background%20with%20soft%20natural%20window%20light%20and%20gentle%20shadows%2C%20minimal%20premium%20clothing%20catalog%20photography%2C%20high%20detail%20fabric%20texture&width=900&height=1100&seq=laelaps-prod-1&orientation=portrait',
  },
  {
    name: 'Laelaps Cursive Long Sleeve',
    price: '$72',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20a%20vintage%20washed%20bone%20cream%20long%20sleeve%20t%20shirt%20with%20elegant%20cursive%20script%20lettering%20across%20chest%2C%20laid%20flat%20on%20warm%20cream%20paper%20background%20with%20soft%20natural%20light%20and%20soft%20shadows%2C%20minimal%20premium%20clothing%20catalog%20photography%2C%20visible%20fabric%20texture%20and%20stitching&width=900&height=1100&seq=laelaps-prod-2&orientation=portrait',
  },
  {
    name: 'Runner Wide Leg Sweatpant',
    price: '$118',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20wide%20leg%20heavyweight%20sweatpants%20in%20faded%20black%20with%20drawstring%20waist%20and%20subtle%20embroidered%20dog%20logo%20on%20hip%2C%20folded%20neatly%20on%20warm%20cream%20paper%20background%20with%20soft%20window%20light%20and%20gentle%20shadows%2C%20minimal%20premium%20streetwear%20catalog%20photography&width=900&height=1100&seq=laelaps-prod-3&orientation=portrait',
  },
  {
    name: 'Mythos Graphic Tee',
    price: '$58',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20a%20washed%20black%20oversized%20graphic%20t%20shirt%20with%20vintage%20running%20wolf%20dog%20illustration%20printed%20on%20chest%2C%20laid%20on%20warm%20cream%20paper%20background%20with%20soft%20natural%20light%20and%20gentle%20shadows%2C%20premium%20minimal%20clothing%20catalog%20photography%2C%20detailed%20fabric%20texture&width=900&height=1100&seq=laelaps-prod-4&orientation=portrait',
  },
  {
    name: 'Chariot Zip Jacket',
    price: '$186',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20a%20boxy%20cropped%20zip%20up%20jacket%20in%20washed%20stone%20grey%20with%20small%20chest%20embroidery%2C%20laid%20flat%20on%20warm%20cream%20paper%20background%20with%20soft%20natural%20window%20light%20and%20soft%20shadows%2C%20premium%20minimal%20streetwear%20catalog%20photography%20with%20visible%20fabric%20weave&width=900&height=1100&seq=laelaps-prod-5&orientation=portrait',
  },
  {
    name: 'Nevada Beanie',
    price: '$38',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20fashion%20product%20photo%20of%20a%20ribbed%20knit%20beanie%20in%20faded%20black%20with%20small%20woven%20label%20showing%20a%20running%20dog%2C%20placed%20on%20warm%20cream%20paper%20background%20with%20soft%20natural%20light%20and%20gentle%20shadows%2C%20premium%20minimal%20accessory%20catalog%20photography%2C%20detailed%20knit%20texture&width=900&height=1100&seq=laelaps-prod-6&orientation=portrait',
  },
];

const upcoming = [
  {
    title: 'Chapter II — Desert Hound',
    date: 'Autumn 2026',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20fashion%20photograph%20of%20a%20model%20standing%20in%20a%20wide%20open%20nevada%20desert%20at%20golden%20hour%20wearing%20heavyweight%20washed%20black%20streetwear%20hoodie%20and%20wide%20leg%20sweatpants%2C%20soft%20warm%20light%20across%20sand%20and%20distant%20mountains%2C%20high%20fashion%20lookbook%20photography%2C%20muted%20warm%20cream%20and%20charcoal%20color%20palette%2C%20grainy%20film%20texture&width=1200&height=1500&seq=laelaps-upcoming-1&orientation=portrait',
  },
  {
    title: 'Chapter III — Neon Nightshift',
    date: 'Winter 2026',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20fashion%20photograph%20of%20a%20model%20walking%20under%20soft%20warm%20neon%20lit%20las%20vegas%20back%20alley%20at%20night%20wearing%20oversized%20washed%20graphic%20long%20sleeve%20tee%20and%20heavyweight%20zip%20jacket%2C%20moody%20amber%20and%20cream%20tones%20not%20blue%20not%20purple%2C%20high%20fashion%20lookbook%20photography%2C%20grainy%20film%20texture%2C%20muted%20warm%20palette&width=1200&height=1500&seq=laelaps-upcoming-2&orientation=portrait',
  },
  {
    title: 'Chapter IV — Marble Mile',
    date: 'Spring 2027',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20fashion%20photograph%20of%20two%20models%20in%20a%20sun%20drenched%20marble%20courtyard%20wearing%20cream%20colored%20long%20sleeve%20tees%20with%20cursive%20script%20and%20wide%20leg%20trousers%2C%20soft%20warm%20natural%20light%20and%20architectural%20shadows%2C%20high%20fashion%20lookbook%20photography%2C%20warm%20cream%20stone%20and%20black%20palette%2C%20grainy%20film%20texture&width=1200&height=1500&seq=laelaps-upcoming-3&orientation=portrait',
  },
];

const heroImg = 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20editorial%20fashion%20photograph%20of%20two%20models%20standing%20motionless%20on%20a%20vast%20empty%20nevada%20salt%20flat%20at%20golden%20hour%2C%20wearing%20heavyweight%20washed%20black%20oversized%20streetwear%20hoodies%20and%20wide%20leg%20sweatpants%2C%20soft%20warm%20cinematic%20sunlight%2C%20distant%20mountain%20silhouettes%2C%20muted%20warm%20cream%20charcoal%20and%20amber%20color%20palette%20absolutely%20no%20blue%20no%20purple%2C%20high%20fashion%20lookbook%20photography%2C%20heavy%20grainy%20film%20texture%2C%20wide%20cinematic%20composition%20with%20lots%20of%20negative%20space%20sky&width=1800&height=1100&seq=laelaps-hero-1&orientation=landscape';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honey = String(fd.get('website_alt') || '').trim();
    if (honey) {
      setStatus('success');
      setEmail('');
      return;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      setFormError('Please enter a valid email address.');
      return;
    }
    fd.delete('website_alt');
    setStatus('loading');
    setFormError('');
    try {
      const body = new URLSearchParams();
      fd.forEach((v, k) => body.append(k, String(v)));
      const res = await fetch('https://readdy.ai/api/form/da109fo3256a3o8kp130', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
      if (res.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setEmail('');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || 'Something went wrong. Please try again.');
      }
    } catch {
      setStatus('error');
      setFormError('Network error. Please try again in a moment.');
    }
  };

  return (
    <div className="min-h-screen bg-bone text-ink font-sans">
      {/* Announcement bar */}
      <div className="w-full bg-ink text-bone text-[11px] tracking-[0.3em] uppercase py-2 overflow-hidden">
        <div className="marquee-track">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-10 px-5">
              <span>Chapter I — Sold Out</span>
              <span>·</span>
              <span>Made in limited runs</span>
              <span>·</span>
              <span>Preview Chapter II Now</span>
              <span>·</span>
              <span>Shipping worldwide from Las Vegas, Nevada</span>
              <span>·</span>
              <span>One email a month. Never more.</span>
              <span>·</span>
            </div>
          ))}
        </div>
      </div>

      {/* Nav */}
      <header
        className={`fixed top-8 left-0 right-0 z-40 transition-all duration-300 ${
          scrolled ? 'bg-bone/95 backdrop-blur border-b border-ink/10' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 md:px-10 h-20 flex items-center justify-between">
          <nav className="hidden md:flex items-center gap-8 text-xs tracking-[0.25em] uppercase">
            <a href="#collection" className="hover:opacity-60 cursor-pointer whitespace-nowrap">Shop</a>
            <a href="#preview" className="hover:opacity-60 cursor-pointer whitespace-nowrap">Preview</a>
            <a href="#story" className="hover:opacity-60 cursor-pointer whitespace-nowrap">Story</a>
          </nav>

          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <img src={LOGO} alt="Laelaps running hound logo" className="w-10 h-10 object-contain" />
            <span className="font-display text-2xl tracking-[0.35em] font-semibold">LAELAPS</span>
          </a>

          <div className="hidden md:flex items-center gap-6 text-xs tracking-[0.25em] uppercase">
            <a href="#journal" className="hover:opacity-60 cursor-pointer whitespace-nowrap">Journal</a>
            <a href="#newsletter" className="hover:opacity-60 cursor-pointer whitespace-nowrap">Join</a>
            <a href="tel:8888663428" className="hover:opacity-60 cursor-pointer whitespace-nowrap">888-866-3428</a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(v => !v)}
            aria-label="Menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu-2'}-line text-2xl`}></i>
          </button>
        </div>
        {menuOpen && (
          <div className="md:hidden bg-bone border-t border-ink/10 px-6 py-6 flex flex-col gap-4 text-sm tracking-[0.25em] uppercase">
            <a href="#collection" onClick={() => setMenuOpen(false)}>Shop</a>
            <a href="#preview" onClick={() => setMenuOpen(false)}>Preview</a>
            <a href="#story" onClick={() => setMenuOpen(false)}>Story</a>
            <a href="#journal" onClick={() => setMenuOpen(false)}>Journal</a>
            <a href="#newsletter" onClick={() => setMenuOpen(false)}>Join</a>
            <a href="tel:8888663428">888-866-3428</a>
          </div>
        )}
      </header>

      {/* Hero */}
      <section id="top" className="relative w-full h-[100vh] min-h-[720px] overflow-hidden">
        <img
          src={heroImg}
          alt="Two models on a Nevada salt flat wearing Laelaps streetwear at golden hour"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-black/50"></div>

        <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-6 md:px-12 text-bone fade-up">
          <div className="w-full max-w-6xl mx-auto">
            <p className="text-xs tracking-[0.4em] uppercase mb-6 opacity-90">Chapter I / Founding Pack</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-4xl">
              The hound never<br /><em className="italic font-normal">catches the moon.</em>
            </h1>
            <p className="mt-8 max-w-xl text-base md:text-lg text-bone/90 leading-relaxed">
              Laelaps is a limited-run streetwear label out of Las Vegas, Nevada.
              Chapter I has sold through. Chapter II is being cut in the desert right now — preview it below.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="#preview"
                className="inline-flex items-center gap-3 bg-bone text-ink px-8 py-4 text-xs tracking-[0.3em] uppercase hover:bg-ink hover:text-bone transition-colors cursor-pointer whitespace-nowrap"
              >
                Preview Chapter II
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#collection"
                className="inline-flex items-center gap-3 border border-bone/60 text-bone px-8 py-4 text-xs tracking-[0.3em] uppercase hover:bg-bone hover:text-ink transition-colors cursor-pointer whitespace-nowrap"
              >
                See Sold Out Chapter I
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 right-6 z-10 text-bone text-[10px] tracking-[0.4em] uppercase opacity-80">
          Las Vegas · NV
        </div>
      </section>

      {/* Marquee */}
      <section className="border-y border-ink/10 bg-bone overflow-hidden py-6">
        <div className="marquee-track font-display text-4xl md:text-6xl italic">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i} className="mx-8 flex items-center gap-8">
              <span>Laelaps</span>
              <i className="ri-star-line text-2xl not-italic"></i>
              <span>The Bronze Hound</span>
              <i className="ri-star-line text-2xl not-italic"></i>
              <span>Est. Las Vegas</span>
              <i className="ri-star-line text-2xl not-italic"></i>
            </span>
          ))}
        </div>
      </section>

      {/* Chapter I sold out grid */}
      <section id="collection" className="w-full px-6 md:px-12 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
            <div>
              <p className="text-xs tracking-[0.4em] uppercase text-ink/60 mb-3">Chapter I / 2026</p>
              <h2 className="font-display text-4xl md:text-6xl">The Founding Pack</h2>
            </div>
            <p className="max-w-md text-sm md:text-base text-ink/70 leading-relaxed">
              Every piece from Chapter I has walked out the door. We do not restock — the pack moves on.
              Sign up below and you'll be the first inside Chapter II.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-product-shop>
            {currentDrop.map((p, i) => (
              <article key={i} className="group relative">
                <div className="relative overflow-hidden bg-[#ece7db] aspect-[4/5]">
                  <img
                    src={p.img}
                    alt={p.name}
                    className="w-full h-full object-cover object-top grayscale-[0.15] group-hover:grayscale-0 transition-all duration-700 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-ink/45 flex items-center justify-center">
                    <div className="border border-bone/70 px-6 py-3 rotate-[-4deg]">
                      <span className="text-bone font-display text-xl md:text-2xl tracking-[0.3em] uppercase">Sold Out</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-baseline justify-between mt-4">
                  <h4 className="text-sm tracking-[0.15em] uppercase">
                    <a href="#collection" className="hover:opacity-60 cursor-pointer">{p.name}</a>
                  </h4>
                  <span className="text-sm text-ink/70 line-through">{p.price}</span>
                </div>
                <p className="text-[11px] tracking-[0.25em] uppercase text-ink/50 mt-1">Chapter I · Archived</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Preview mode */}
      <section id="preview" className="relative w-full bg-ink text-bone py-20 md:py-28 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-2 rounded-full bg-bone animate-pulse"></span>
            <p className="text-xs tracking-[0.4em] uppercase text-bone/70">Preview Mode · Not Yet Released</p>
          </div>
          <h2 className="font-display text-4xl md:text-6xl max-w-3xl leading-[1.05]">
            Look ahead. <em className="italic">Nothing is for sale here — yet.</em>
          </h2>
          <p className="mt-6 max-w-xl text-bone/70 leading-relaxed">
            Watch the next three chapters take shape. Preview only means no cart, no size chart, no restock alerts —
            just the work as it comes out of the studio.
          </p>

          <div className="mt-14 grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3">
              <div className="relative aspect-[4/5] overflow-hidden bg-[#1c1c1c]">
                <img
                  src={upcoming[previewIndex].img}
                  alt={upcoming[previewIndex].title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  key={previewIndex}
                />
                <div className="absolute top-4 left-4 bg-bone text-ink text-[10px] tracking-[0.3em] uppercase px-3 py-1">
                  Preview
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-xs tracking-[0.35em] uppercase text-bone/70">{upcoming[previewIndex].date}</p>
                  <h3 className="font-display text-3xl md:text-5xl mt-2">{upcoming[previewIndex].title}</h3>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2 flex flex-col justify-between gap-6">
              <div className="flex flex-col gap-3">
                {upcoming.map((u, i) => (
                  <button
                    key={i}
                    onClick={() => setPreviewIndex(i)}
                    className={`text-left border p-5 transition-all cursor-pointer ${
                      previewIndex === i
                        ? 'border-bone bg-bone/5'
                        : 'border-bone/20 hover:border-bone/50'
                    }`}
                  >
                    <div className="flex items-center justify-between text-[10px] tracking-[0.35em] uppercase text-bone/60">
                      <span>0{i + 2}</span>
                      <span>{u.date}</span>
                    </div>
                    <div className="mt-2 font-display text-2xl">{u.title.replace(/^Chapter [IVX]+ — /, '')}</div>
                  </button>
                ))}
              </div>

              <div className="border border-bone/20 p-6">
                <p className="text-[11px] tracking-[0.35em] uppercase text-bone/60 mb-2">Access</p>
                <p className="text-sm text-bone/80 leading-relaxed">
                  Chapter II drops to newsletter subscribers first — 48 hours before public. Join below.
                  We send one email a month. That's it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story */}
      <section id="story" className="w-full px-6 md:px-12 py-20 md:py-28">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-xs tracking-[0.4em] uppercase text-ink/60 mb-4">The Name</p>
            <h2 className="font-display text-4xl md:text-5xl leading-[1.05]">
              Named for a hound that <em className="italic">was destined to always catch its prey.</em>
            </h2>
            <p className="mt-6 text-ink/70 leading-relaxed">
              In myth, Laelaps was a dog that could never lose a chase — set against a fox that could never be caught.
              We take the same idea into every piece: made to outlast the season, made in small numbers so the chase never ends.
            </p>
            <p className="mt-4 text-ink/70 leading-relaxed">
              We cut and finish in Las Vegas, Nevada. Every drop is a chapter. Once it's gone, it's gone.
            </p>
          </div>
          <div className="relative aspect-[4/5] bg-[#ece7db] overflow-hidden grain">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20black%20and%20white%20film%20photograph%20of%20a%20quiet%20small%20streetwear%20studio%20interior%20in%20las%20vegas%20nevada%20with%20a%20single%20industrial%20sewing%20machine%20and%20a%20rack%20of%20heavyweight%20hoodies%2C%20warm%20natural%20window%20light%20across%20wood%20floor%20and%20cream%20plaster%20walls%2C%20soft%20shadows%2C%20grainy%20film%20texture%2C%20muted%20warm%20cream%20and%20charcoal%20palette%20no%20blue%20no%20purple&width=900&height=1100&seq=laelaps-story-1&orientation=portrait"
              alt="Laelaps studio in Las Vegas"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      {/* Journal / editorial strip */}
      <section id="journal" className="w-full bg-[#ece7db] py-20 md:py-28 border-y border-ink/10">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
            <div>
              <p className="text-xs tracking-[0.4em] uppercase text-ink/60 mb-3">Journal</p>
              <h2 className="font-display text-4xl md:text-5xl">Notes from the studio</h2>
            </div>
            <span className="text-xs tracking-[0.3em] uppercase text-ink/50">Vol. 03 · Aug 2026</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                t: 'Why we sold out in 41 minutes',
                d: 'Aug 02, 2026',
                img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20folded%20heavyweight%20black%20hoodies%20stacked%20neatly%20on%20a%20warm%20cream%20wooden%20table%20with%20a%20small%20paper%20order%20tag%2C%20soft%20natural%20window%20light%2C%20muted%20warm%20cream%20and%20charcoal%20palette%2C%20grainy%20film%20texture%2C%20premium%20minimal%20lifestyle%20photography&width=800&height=600&seq=laelaps-journal-1&orientation=landscape',
              },
              {
                t: 'Inside the Chapter II fittings',
                d: 'Jul 21, 2026',
                img: 'https://readdy.ai/api/search-image?query=Editorial%20behind%20the%20scenes%20photograph%20of%20a%20streetwear%20fitting%20with%20tailors%20chalk%20marks%20on%20a%20washed%20black%20oversized%20hoodie%20on%20a%20mannequin%2C%20studio%20with%20cream%20walls%20and%20warm%20window%20light%2C%20muted%20warm%20palette%20no%20blue%20no%20purple%2C%20grainy%20film%20texture%2C%20high%20fashion%20lookbook%20style&width=800&height=600&seq=laelaps-journal-2&orientation=landscape',
              },
              {
                t: 'The desert dye process',
                d: 'Jul 09, 2026',
                img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20hand%20dyed%20heavyweight%20cotton%20garments%20hanging%20on%20a%20clothesline%20in%20a%20nevada%20desert%20yard%20at%20golden%20hour%2C%20warm%20amber%20light%20across%20sand%20and%20cream%20fabric%2C%20muted%20warm%20palette%2C%20grainy%20film%20texture%2C%20high%20end%20streetwear%20lifestyle%20photography&width=800&height=600&seq=laelaps-journal-3&orientation=landscape',
              },
            ].map((a, i) => (
              <article key={i} className="group cursor-pointer">
                <div className="aspect-[4/3] overflow-hidden bg-[#ded8ca]">
                  <img src={a.img} alt={a.t} className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700" />
                </div>
                <div className="mt-4">
                  <p className="text-[11px] tracking-[0.3em] uppercase text-ink/50">{a.d}</p>
                  <h4 className="mt-2 font-display text-2xl leading-tight">
                    <a href="#journal" className="hover:opacity-60 cursor-pointer">{a.t}</a>
                  </h4>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section id="newsletter" className="w-full px-6 md:px-12 py-24 md:py-32 relative overflow-hidden">
        <div className="max-w-3xl mx-auto text-center">
          <img src={LOGO} alt="Laelaps logo" className="w-16 h-16 mx-auto object-contain mb-6" />
          <p className="text-xs tracking-[0.4em] uppercase text-ink/60 mb-4">Join The Pack</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05]">
            One email a month. <em className="italic">Never more.</em>
          </h2>
          <p className="mt-6 text-ink/70 max-w-xl mx-auto leading-relaxed">
            Enter your email to get first access to Chapter II and every chapter after. That's the only reason we'll write.
            No promos, no reminders, no noise — we promise to send no more than one email per month.
          </p>

          <form
            ref={formRef}
            onSubmit={handleSubmit}
            data-readdy-form
            id="laelaps-newsletter"
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
            noValidate
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 px-5 py-4 bg-transparent border border-ink/30 text-sm placeholder:text-ink/40 focus:outline-none focus:border-ink transition-colors"
            />
            {/* Honeypot */}
            <div className="field-supplemental" aria-hidden="true">
              <label>
                Website
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                  defaultValue=""
                />
              </label>
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-ink text-bone px-8 py-4 text-xs tracking-[0.3em] uppercase hover:bg-ink/80 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? 'Joining…' : 'Join'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-6 text-sm text-ink/80">You're in. Watch your inbox once a month — no sooner.</p>
          )}
          {status === 'error' && (
            <p className="mt-6 text-sm text-red-700">{formError || 'Something went wrong. Please try again.'}</p>
          )}

          <p className="mt-6 text-[11px] tracking-[0.25em] uppercase text-ink/50">
            No contact form · No spam · Unsubscribe any time
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#1a1a1a] text-bone">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-2">
              <div className="flex items-center gap-3">
                <img src={LOGO} alt="Laelaps" className="w-10 h-10 object-contain invert" />
                <span className="font-display text-2xl tracking-[0.35em]">LAELAPS</span>
              </div>
              <p className="mt-5 text-sm text-bone/70 max-w-sm leading-relaxed">
                Limited-run streetwear, cut and finished in Las Vegas, Nevada.
                The hound never catches the moon — that's the whole point.
              </p>
              <div className="mt-6 flex items-center gap-4 text-bone/70">
                <a href="#" className="w-9 h-9 flex items-center justify-center border border-bone/20 hover:border-bone cursor-pointer"><i className="ri-instagram-line"></i></a>
                <a href="#" className="w-9 h-9 flex items-center justify-center border border-bone/20 hover:border-bone cursor-pointer"><i className="ri-tiktok-line"></i></a>
                <a href="#" className="w-9 h-9 flex items-center justify-center border border-bone/20 hover:border-bone cursor-pointer"><i className="ri-twitter-x-line"></i></a>
                <a href="#" className="w-9 h-9 flex items-center justify-center border border-bone/20 hover:border-bone cursor-pointer"><i className="ri-youtube-line"></i></a>
              </div>
            </div>

            <div>
              <p className="text-[11px] tracking-[0.35em] uppercase text-bone/50 mb-4">Explore</p>
              <ul className="space-y-2 text-sm text-bone/80">
                <li><a href="#collection" className="hover:text-bone cursor-pointer">Chapter I (Sold Out)</a></li>
                <li><a href="#preview" className="hover:text-bone cursor-pointer">Preview Chapter II</a></li>
                <li><a href="#story" className="hover:text-bone cursor-pointer">Our Story</a></li>
                <li><a href="#journal" className="hover:text-bone cursor-pointer">Journal</a></li>
              </ul>
            </div>

            <div>
              <p className="text-[11px] tracking-[0.35em] uppercase text-bone/50 mb-4">Reach Us</p>
              <ul className="space-y-2 text-sm text-bone/80">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5"></i>
                  <span>Las Vegas, Nevada<br />United States</span>
                </li>
                <li>
                  <a href="tel:8888663428" className="flex items-center gap-2 hover:text-bone cursor-pointer">
                    <i className="ri-phone-line"></i>
                    <span>Toll-free 888-866-3428</span>
                  </a>
                </li>
                <li className="text-bone/60 text-xs leading-relaxed pt-2">
                  Mon–Fri · 10am–5pm PT
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-bone/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[11px] tracking-[0.25em] uppercase text-bone/50">
            <span>© 2026 Laelaps · laelaps.online</span>
            <span>Made in Las Vegas, Nevada</span>
          </div>
        </div>
      </footer>
    </div>
  );
}